import { gql } from '@apollo/client';

export const UPSERT_USER_SECURITY_QUESTIONS_ANSWERS = gql`
  mutation UpsertUserSecurityQuestionsAndAnswers(
    $data: [UpsertUserSecurityQuestionsInput!]!
  ) {
    upsertUserSecurityQuestionsAndAnswers(data: $data)
  }
`;
